/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useSelector} from "react-redux";

export const useIsAuthenticated = () => {
    const user = useSelector(state => state.userState.user);
    const {
        publicContext = false,
        twoFactorRequired = false,
        activeUntil = null,
    } = user ?? {};
    
    const isActive = Boolean(activeUntil && (new Date(activeUntil) > new Date()));
    
    return isActive && !twoFactorRequired && !publicContext;
}
